module.exports = __webpack_public_path__ + "img/marina.74232439.png";